// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","black":"#333","grey":"#ccc","brandBlue":"#2a75b3","errorRed":"#f44336"};